.option {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 6px 24px;
}
.option:hover {
  background-color: var(--color-easil-gray-xx-light);
}

.selected {
  line-height: 1;
  margin-left: 16px;
}

.countryNameFlagWrapper {
  display: flex;
  align-items: center;
}

.name {
  color: var(--color-easil-black);
  margin-left: 12px;
}
